(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bala-fair-trade-story"] && !Shopify.designMode) return;
  try {
    
  const initBalaFairTrade = (root) => {
    if (!root || root.dataset.balaFtReady === 'true') return;

    const trigger = root.querySelector('[data-bala-video-open]');
    const dialog = root.querySelector('[data-bala-video-dialog]');
    const closeButton = root.querySelector('[data-bala-video-close]');

    if (!trigger || !dialog || !closeButton) {
      root.dataset.balaFtReady = 'true';
      return;
    }

    const video = dialog.querySelector('video');

    const stopVideo = () => {
      if (!video) return;
      video.pause();
      video.currentTime = 0;
    };

    trigger.addEventListener('click', () => {
      dialog.showModal();
      if (video) {
        const playRequest = video.play();
        if (playRequest) playRequest.catch(() => {});
      }
    });

    closeButton.addEventListener('click', () => {
      dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      stopVideo();
      trigger.focus();
    });

    root.dataset.balaFtReady = 'true';
  };

  const initAllBalaFairTrade = (scope = document) => {
    scope.querySelectorAll('[data-bala-ft]').forEach(initBalaFairTrade);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllBalaFairTrade());
  } else {
    initAllBalaFairTrade();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllBalaFairTrade(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bala-hero-button-fix"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bala-hero-button-fix')) {
    const trackFileDownload = async (element, source) => {
      try {
        const fileUrl = new URL(source, window.location.href);
        if (fileUrl.protocol !== 'https:' && fileUrl.protocol !== 'http:') return;
        const extension = fileUrl.pathname.match(/\.([a-z0-9]+)$/i);
        const parameters = {
          send_to: 'G-WJF5V9J1B9',
          file_extension: extension ? extension[1].toLowerCase() : '',
          file_name: fileUrl.pathname,
          link_url: fileUrl.href,
          link_text: element.textContent.trim(),
          link_id: element.id || '',
          link_classes: element.className || ''
        };
        const shopify = window.Shopify;
        if (!shopify) return;
        let privacy = shopify.customerPrivacy;
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
          if (typeof shopify.loadFeatures !== 'function') return;
          privacy = await new Promise((resolve) => {
            shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
              resolve(error ? null : shopify.customerPrivacy);
            });
          });
        }
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
        if (privacy.analyticsProcessingAllowed() !== true || !Array.isArray(window.dataLayer)) return;
        function sendGoogleEvent() {
          window.dataLayer.push(arguments);
        }
        sendGoogleEvent('event', 'file_download', parameters);
      } catch (error) {}
    };

    class BalaHeroButtonFix extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-bala-pdf-dialog]');
        this.frame = this.querySelector('[data-bala-pdf-frame]');
        this.pages = this.querySelector('[data-bala-pdf-pages]');
        this.titleElement = this.querySelector('[data-bala-pdf-title]');
        this.fullSizeLink = this.querySelector('[data-bala-pdf-full]');
        this.downloadButton = this.querySelector('[data-bala-pdf-download]');
        this.statusElement = this.querySelector('[data-bala-pdf-status]');
        this.controller = new AbortController();
        this.renderToken = 0;
        const signal = this.controller.signal;

        document.addEventListener('click', (event) => {
          if (!(event.target instanceof Element) || event.defaultPrevented) return;
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

          const link = event.target.closest('.bala-retail-hero__buttons a[href]');
          if (!link || !/\.pdf$/i.test(new URL(link.href).pathname) || !this.dialog?.showModal) return;

          event.preventDefault();
          this.open(link);
        }, { signal });

        this.querySelector('[data-bala-pdf-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
        this.downloadButton?.addEventListener('click', () => this.download(), { signal });
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        }, { signal });
        this.dialog?.addEventListener('close', () => {
          this.clearPreview();
          this.frame.src = 'about:blank';
          document.body.classList.remove('bala-hero-pdf-open');
          this.previousFocus?.focus();
        }, { signal });
      }

      disconnectedCallback() {
        this.clearPreview();
        this.controller?.abort();
      }

      clearPreview() {
        this.renderToken += 1;
        this.renderTask?.cancel();
        this.renderTask = null;
        this.loadingTask?.destroy();
        this.loadingTask = null;
        this.pages?.replaceChildren();
        if (this.pages) this.pages.hidden = true;
        if (this.frame) this.frame.hidden = false;
      }

      open(link) {
        if (this.dialog.open) return;
        this.previousFocus = link;
        const title = link.textContent.trim() || 'Document preview';
        this.titleElement.textContent = title;
        this.frame.title = title;
        this.pdfUrl = link.href;
        this.fullSizeLink.href = link.href;
        this.statusElement.hidden = true;
        this.dialog.showModal();
        if (window.matchMedia('(max-width: 640px)').matches) {
          this.frame.hidden = true;
          this.pages.hidden = false;
          this.renderMobilePdf();
        } else {
          this.frame.hidden = false;
          this.pages.hidden = true;
          this.frame.src = link.href;
        }
        document.body.classList.add('bala-hero-pdf-open');
      }

      async renderMobilePdf() {
        const token = ++this.renderToken;
        this.pages.textContent = 'Loading PDF…';

        try {
          const pdfjs = await import(this.dataset.pdfjsModule);
          if (token !== this.renderToken) return;
          pdfjs.GlobalWorkerOptions.workerSrc = this.dataset.pdfjsWorker;
          this.loadingTask = pdfjs.getDocument({ url: this.pdfUrl });
          const pdf = await this.loadingTask.promise;
          if (token !== this.renderToken) return;

          let firstPage = true;
          for (let number = 1; number <= pdf.numPages; number += 1) {
            if (token !== this.renderToken) return;
            const page = await pdf.getPage(number);
            if (token !== this.renderToken) return;

            const base = page.getViewport({ scale: 1 });
            const width = this.pages.clientWidth - 24;
            const viewport = page.getViewport({ scale: Math.min(1, width / base.width) });
            const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            if (!context) throw new Error('Canvas unavailable');
            canvas.width = Math.floor(viewport.width * pixelRatio);
            canvas.height = Math.floor(viewport.height * pixelRatio);
            canvas.style.width = `${Math.floor(viewport.width)}px`;
            canvas.style.height = `${Math.floor(viewport.height)}px`;
            const wrapper = document.createElement('div');
            wrapper.className = 'bala-hero-button-fix__page';
            wrapper.style.width = canvas.style.width;
            wrapper.style.height = canvas.style.height;
            wrapper.appendChild(canvas);

            this.renderTask = page.render({
              canvasContext: context,
              viewport,
              transform: pixelRatio === 1 ? null : [pixelRatio, 0, 0, pixelRatio, 0, 0]
            });
            await this.renderTask.promise;
            this.renderTask = null;
            if (token !== this.renderToken) return;
            if (firstPage) {
              this.pages.replaceChildren();
              firstPage = false;
            }
            this.pages.appendChild(wrapper);
            page.cleanup();
          }
        } catch (error) {
          if (token !== this.renderToken) return;
          this.pages.textContent = 'Preview could not load. Use Open full size or Download PDF.';
        }
      }

      async download() {
        if (!this.pdfUrl || this.downloadButton.disabled) return;
        this.downloadButton.disabled = true;
        trackFileDownload(this.downloadButton, this.pdfUrl);
        this.downloadButton.textContent = 'Preparing PDF…';
        this.statusElement.hidden = true;

        try {
          const response = await fetch(this.pdfUrl, { credentials: 'omit' });
          if (!response.ok) throw new Error('PDF download failed');
          const blob = await response.blob();
          if (!blob.size) throw new Error('Empty PDF');

          const pdfName = decodeURIComponent(new URL(this.pdfUrl).pathname.split('/').pop() || 'Bala-Sport-document.pdf');
          const objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = /\.pdf$/i.test(pdfName) ? pdfName : 'Bala-Sport-document.pdf';
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
        } catch (error) {
          this.statusElement.textContent = 'Download could not start here. Open full size and use your browser’s Save or Share option.';
          this.statusElement.hidden = false;
        } finally {
          this.downloadButton.disabled = false;
          this.downloadButton.textContent = 'Download PDF';
        }
      }
    }

    customElements.define('bala-hero-button-fix', BalaHeroButtonFix);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bala-resource-downloads"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const trackFileDownload = async (element, source) => {
      try {
        const fileUrl = new URL(source, window.location.href);
        if (fileUrl.protocol !== 'https:' && fileUrl.protocol !== 'http:') return;
        const extension = fileUrl.pathname.match(/\.([a-z0-9]+)$/i);
        const parameters = {
          send_to: 'G-WJF5V9J1B9',
          file_extension: extension ? extension[1].toLowerCase() : '',
          file_name: fileUrl.pathname,
          link_url: fileUrl.href,
          link_text: element.textContent.trim(),
          link_id: element.id || '',
          link_classes: element.className || ''
        };
        const shopify = window.Shopify;
        if (!shopify) return;
        let privacy = shopify.customerPrivacy;
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
          if (typeof shopify.loadFeatures !== 'function') return;
          privacy = await new Promise((resolve) => {
            shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
              resolve(error ? null : shopify.customerPrivacy);
            });
          });
        }
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
        if (privacy.analyticsProcessingAllowed() !== true || !Array.isArray(window.dataLayer)) return;
        function sendGoogleEvent() {
          window.dataLayer.push(arguments);
        }
        sendGoogleEvent('event', 'file_download', parameters);
      } catch (error) {}
    };

    const filenameFromDisposition = (value) => {
      if (!value) return '';

      const encodedMatch = value.match(/filename\*=UTF-8''([^;]+)/i);
      if (encodedMatch) {
        try {
          return decodeURIComponent(encodedMatch[1].replace(/["']/g, '').trim());
        } catch (error) {
          return encodedMatch[1].replace(/["']/g, '').trim();
        }
      }

      const basicMatch = value.match(/filename=["']?([^"';]+)["']?/i);
      return basicMatch ? basicMatch[1].trim() : '';
    };

    const filenameFromUrl = (value) => {
      try {
        const url = new URL(value, window.location.href);
        const name = decodeURIComponent(url.pathname.split('/').filter(Boolean).pop() || 'resource');
        return name || 'resource';
      } catch (error) {
        return 'resource';
      }
    };

    const setDownloadStatus = (link, message, state = '') => {
      const dialog = link.closest('dialog');
      const status = dialog ? dialog.querySelector('[data-resource-download-status]') : null;
      if (!status) return;

      status.textContent = message;
      status.hidden = message === '';

      if (state) {
        status.dataset.state = state;
      } else {
        delete status.dataset.state;
      }
    };

    const triggerBlobDownload = (blob, filename) => {
      const objectUrl = URL.createObjectURL(blob);
      const temporaryLink = document.createElement('a');
      temporaryLink.href = objectUrl;
      temporaryLink.download = filename || 'resource';
      temporaryLink.style.display = 'none';
      document.body.appendChild(temporaryLink);
      temporaryLink.click();
      temporaryLink.remove();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 30000);
    };

    const downloadResource = async (link) => {
      if (link.getAttribute('aria-busy') === 'true') return;
      const requestedUrl = link.href;
      const preferredName = link.dataset.downloadName || filenameFromUrl(requestedUrl);

      link.setAttribute('aria-busy', 'true');
      trackFileDownload(link, requestedUrl);
      setDownloadStatus(link, 'Preparing download…');

      try {
        const response = await fetch(requestedUrl, {
          credentials: 'same-origin',
          redirect: 'follow'
        });

        if (!response.ok) {
          throw new Error(`The file returned an HTTP ${response.status} response.`);
        }

        const contentType = (response.headers.get('content-type') || '').toLowerCase();
        if (contentType.includes('text/html') || contentType.includes('application/xhtml+xml')) {
          throw new Error('This link points to a web page rather than the uploaded resource. Copy the file link from Shopify Content → Files, or enter the exact uploaded filename including its extension.');
        }

        const blob = await response.blob();
        if (!blob.size) {
          throw new Error('The downloaded file was empty.');
        }

        const dispositionName = filenameFromDisposition(response.headers.get('content-disposition'));
        const finalName = dispositionName || preferredName || filenameFromUrl(response.url || requestedUrl);
        triggerBlobDownload(blob, finalName);
        setDownloadStatus(link, 'Download started.');
      } catch (error) {
        setDownloadStatus(link, error.message || 'The resource could not be downloaded.', 'error');
      } finally {
        link.removeAttribute('aria-busy');
      }
    };

    const initialiseResourceSections = (root = document) => {
      root.querySelectorAll('[data-bala-resource-section]').forEach((section) => {
        if (section.dataset.resourceSectionReady === 'true') return;
        section.dataset.resourceSectionReady = 'true';

        section.addEventListener('click', async (event) => {
          const downloadLink = event.target.closest('[data-resource-download]');
          if (downloadLink && section.contains(downloadLink)) {
            event.preventDefault();
            await downloadResource(downloadLink);
            return;
          }

          const opener = event.target.closest('[data-resource-modal-open]');
          if (opener && section.contains(opener)) {
            const dialog = document.getElementById(opener.dataset.resourceModalOpen);
            if (!dialog) return;

            if (typeof dialog.showModal === 'function') {
              dialog.showModal();
            } else {
              dialog.setAttribute('open', '');
            }
          }

          const closer = event.target.closest('[data-resource-modal-close]');
          if (closer && section.contains(closer)) {
            const dialog = closer.closest('dialog');
            if (!dialog) return;

            if (typeof dialog.close === 'function') {
              dialog.close();
            } else {
              dialog.removeAttribute('open');
            }
          }
        });

        section.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target !== dialog) return;

            if (typeof dialog.close === 'function') {
              dialog.close();
            } else {
              dialog.removeAttribute('open');
            }
          });

          dialog.addEventListener('close', () => {
            dialog.querySelectorAll('video').forEach((video) => video.pause());
            const status = dialog.querySelector('[data-resource-download-status]');
            if (status) {
              status.textContent = '';
              status.hidden = true;
              delete status.dataset.state;
            }
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseResourceSections());
    } else {
      initialiseResourceSections();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseResourceSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
